import { yupResolver } from "@hookform/resolvers/yup";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { SdsForm } from "soft_digi";
import { SdsFormElementProps } from "soft_digi/dist/sdforms/SdsFromInterFace";
import * as Yup from "yup";
import { INVOICE_URLS } from "../../api/UserUrls";
import { useSiteContext } from "../../contexts/SiteProvider";
import { changeDateTimeZoneFormat } from "../../services/core/CommonService";
import { post } from "../../services/smartApiService";
import { vendors_get_all_select } from "../../services/site/SelectBoxServices";
interface FormErrors {
  [key: string]: string | null;
}
interface HeaderProps {
  loadTableData: () => void;
  dataIn: any;
}
const schema = Yup.object({
  bill_start_date: Yup.date()
    .required("Start Date is required")
    .typeError("Invalid date format"),
  bill_end_date: Yup.date()
    .required("End Date is required")
    .typeError("Invalid date format")
    .min(Yup.ref("bill_start_date"), "End Date must be after Start Date"),
  invoice_date: Yup.date()
    .required("Invoice Date is required")
    .typeError("Invalid date format"),
  due_date: Yup.date()
    .required("Due Date is required")
    .typeError("Invalid date format"),
});
const InvoicebillForm: React.FC<HeaderProps> = ({ loadTableData, dataIn }) => {
  //console.log("data In " , dataIn);
  // const [formData, setFormData] = useState(dataIn ? dataIn : {});

  const { openModal, closeModal } = useSiteContext();
  const navigate = useNavigate();
  const [minEndDate, setMinEndDate] = useState<Date | null>(null);
  const {
    control,
    handleSubmit,
    watch,
    formState: { errors },
    setValue,
  } = useForm({
    defaultValues: dataIn,
    //     defaultValues: {
    //   ...dataIn,
    //   included_vendors: dataIn?.included_vendors
    //     ? { value: dataIn.included_vendors, label: dataIn.included_vendors }
    //     : null,
    //   excluded_vendors: dataIn?.excluded_vendors
    //     ? { value: dataIn.excluded_vendors, label: dataIn.excluded_vendors }
    //     : null,
    // },
    resolver: yupResolver(schema),
  });
  const [allVendors, setAllVendors] = useState([]);
  const bill_start_date = watch("bill_start_date");
  useEffect(() => {
    if (bill_start_date && moment(bill_start_date).isValid()) {
      const startDate = moment(bill_start_date).toDate();
      setMinEndDate(startDate);
    }
  }, [bill_start_date]);

  // useEffect(() => {
  //   if (
  //     bill_start_date &&
  //     moment(bill_start_date).isValid()
  //   ) {
  //     const startDate = moment(bill_start_date);
  //     const newEndDate = startDate.add(1, "month").date(20).endOf("day");
  //     setMinEndDate(newEndDate.toDate());
  //     // setValue("bill_end_date", newEndDate.toDate());
  //     //handleInputChange("bill_end_date", newEndDate.toDate());
  //   }
  // }, [bill_start_date]);

  // const handleSubmit = () => {
  //   setFormSubmit(true);
  //   if (!ValidateFormNew(formData, filterFields)) {
  //     return false;
  //   }
  //   let URL = formData.ID ? INVOICE_URLS.BILL_UPDATE : INVOICE_URLS.GENERATE;
  //   let _data = {
  //     bill_start_date: changeDateTimeZoneFormat(
  //       formData.bill_start_date || "",
  //       "YYYY-MM-DD"
  //     ),
  //     bill_end_date: changeDateTimeZoneFormat(
  //       formData.bill_end_date || "",
  //       "YYYY-MM-DD"
  //     ),
  //     invoice_date: formData.invoice_date,
  //     due_date: formData.due_date,
  //     id:formData?.ID
  //   };
  //   const subscription = post(URL, _data).subscribe((response) => {
  //     navigate("/e-fuel/vendor-wish/" + response.data);
  //     closeModal();
  //     //showAlertAutoClose("Bill Cre")
  //     // setData(response.data);
  //     loadTableData()
  //   });
  //   return () => {
  //     subscription.unsubscribe();
  //   };
  // };
  const onSubmit = (data: any) => {
    let URL = dataIn?.ID ? INVOICE_URLS.BILL_UPDATE : INVOICE_URLS.GENERATE;

    const _data = {
      id: dataIn?.ID || 0,

      bill_start_date: changeDateTimeZoneFormat(
        data.bill_start_date,
        "YYYY-MM-DD"
      ),

      bill_end_date: changeDateTimeZoneFormat(data.bill_end_date, "YYYY-MM-DD"),

      invoice_date: changeDateTimeZoneFormat(data.invoice_date, "YYYY-MM-DD"),

      due_date: changeDateTimeZoneFormat(data.due_date, "YYYY-MM-DD"),

      excluded_vendors: data.excluded_vendors || [],
      included_vendors: data.included_vendors || [],
    };

    // console.log("FINAL SUBMIT PAYLOAD ---->", _data);

    const subscription = post(URL, _data).subscribe((response) => {
      navigate("/e-fuel/vendor-wish/" + response.data);
      closeModal();
      loadTableData();
    });

    return () => subscription.unsubscribe();
  };

  useEffect(() => {
    vendors_get_all_select((data: any) => setAllVendors(data));
  }, []);

  const formElements: SdsFormElementProps[] = [
    {
      type: "DATE",
      width: 6,
      name: "bill_start_date",
      element: {
        label: "Start Date",
        placeHolder: "DD-MM-YYYY",
        isRequired: true,
        inputType: "BORDER_LABEL",
        // validations: hubFormValidations.start,
        // disabled: dataIn.ID ? true : false,
        // minDate: new Date(),
        // inputProps: { isFocussed: true },
      },
    },
    {
      type: "DATE",
      width: 6,
      name: "bill_end_date",
      element: {
        label: "End Date",
        placeHolder: "DD-MM-YYYY",
        isRequired: true,
        // minDate: minEndDate,
        // inputProps: { disabled: true },
        // disabled: dataIn.ID ? true : false,
        inputType: "BORDER_LABEL",
        // validations: hubFormValidations.end,
      },
    },
    {
      type: "DATE",
      width: 6,
      name: "invoice_date",
      element: {
        label: "Invoice Date",
        placeHolder: "DD-MM-YYYY",
        isRequired: true,
        // minDate: minEndDate,
        // inputProps: { disabled: true },
        inputType: "BORDER_LABEL",
        // validations: hubFormValidations.end,
      },
    },
    {
      type: "DATE",
      width: 6,
      name: "due_date",
      element: {
        label: "Due Date",
        placeHolder: "DD-MM-YYYY",
        isRequired: true,
        // minDate: minEndDate,
        // inputProps: { disabled: true },
        inputType: "BORDER_LABEL",
        // validations: hubFormValidations.end,
      },
    },
    {
      type: "SELECT_BOX",
      width: 6,
      name: "excluded_vendors",
      element: {
        label: "Excluded Vendors",
        isMulti: true,
        inputType: "BORDER_LABEL",
        options: allVendors,
      },
    },
    {
      type: "SELECT_BOX",
      width: 6,
      name: "included_vendors",
      element: {
        label: "Included Vendors",
        isMulti: true,
        inputType: "BORDER_LABEL",
        options: allVendors,
      },
    },
    { type: "LABEL", width: 6, name: "label" },
    {
      type: "BUTTON",
      width: 12,
      name: "invoice_button",
      class_name: "has-text-right",
      element: {
        label: "Create Bill",
        classList: ["smart-action-button mt-0 has-text-right"],
        onClick: handleSubmit(onSubmit),
      },
    },
  ];
  return (
    <>
      <div className="sd-efl-input">
        <div className="">
          {/* <SmartSoftForm
            formData={formData}
            setFormData={handleInputChange}
            elements={filterFields}
            formSubmit={formSubmit}
            handleErrorChange={handleErrorChange}
          /> */}
          <SdsForm elements={formElements} errors={errors} control={control} />
        </div>
      </div>
    </>
  );
};

export default InvoicebillForm;
